<template>
  <div id="voteOption">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            投票選項
          </div>
        </div>
      </div>
      <el-tabs
        id="voteTab"
        v-model="activeName"
        :before-leave="checkTab"
      >
        <el-tab-pane name="voteDetail">
          <span slot="label">投票內容</span>
        </el-tab-pane>
        <el-tab-pane name="commentManagement">
          <span slot="label">留言管理</span>
        </el-tab-pane>
      </el-tabs>
      <router-view ref="view" />
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  computed: {
    activeName: {
      get () {
        return this.$route.name
      },
      set (val) {
        return val
      }
    }
  },
  mounted () {
  },
  methods: {
    checkTab (activeName, oldActiveName) {
      if (activeName !== oldActiveName) {
        this.$router.push({ name: activeName })
      }
    }
  }
}
</script>

<style lang="sass" scoped>
#voteOption
  padding: 50px 0 10px
  height: 100%
  .main
    min-width: 1140px
    max-width: 90%
    margin: 0 auto
    padding: 30px
    color: $mainFontColor
    background-color: #fff
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)
    border-radius: $pageBorderRadius
    box-sizing: border-box
    .title_bar
      display: flex
      justify-content: space-between
      align-items: center
      margin: 0 0 20px 0
      .introduction
        color: $mainColorDark
        font-size: 20px
        font-weight: initial
        margin: 0 10px
        text-decoration: underline
        cursor: pointer
        &:before
          content: '('
          color: #000
        &:after
          content: ')'
          color: #000
      .questionnaire
        background-color: $bgDark3
        padding: 5px 8px
        span
          color: $mainColor
          cursor: pointer
          margin: 0 10px 0 13px
      .title
        font-weight: bold
        font-size: map-get($fontSize,xx-large)
        margin-bottom: 10px
        text-align: left
      .tip
        font-size: map-get($fontSize,small)
        color: $subFontColor
    .title_bar.center
      margin: 20px 0 10px 0
    .el-tabs
      text-align: center
#voteTab
  ::v-deep .el-tabs
    +basicTabs
    &__header
      margin: 0 0 0
    &__item
      min-width: 130px
      height: 42px
      span
        width: 100%
        display: inline-block
</style>
